import styled from "styled-components";

export const OccurrenceTitle = styled.span`
  font-weight: bold;
  font-size: 14px;
  line-height: 11px;
  margin-bottom: 4px;
  flex: 1;
  color: var(--luft-secondary-darker);
`;

export const OccurrenceDate = styled.span`
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  margin-bottom: 8px;
  color: var(--dark-blue);
`;

export const RegisteredDate = styled.span`
  font-style: italic;
  font-weight: normal;
  font-size: 12px;
  line-height: 14px;
  display: flex;
  align-items: center;
  margin-bottom: 4px;
  color: var(--light-opacity-gray);
`;

export const UserName = styled.span`
  font-weight: normal;
  font-size: 12px;
  line-height: 14px;
  color: var(--light-opacity-gray);
`;

export const DetailsOccurrences = styled.div`
  width: 100%;
`;

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
`

export const OccurrenceContainer = styled.div`
  padding: 20px 20px 0 20px;
  margin-top: 10px;
  border-radius: 4px;
  border: 1px solid var(--secondary-gray);
  width: 100%;

  @media all and (min-width: 768px) {
    width: 95%;
  }
`;

export const OccurrenceInfo = styled.div`
  margin-left: 12px;
  margin-bottom: 24px;
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const OccurrenceWrapper = styled.div`
  display: flex;
`;

export const Tumb = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: var(--luft-secondary-darker);
`;

export const Line = styled.div`
  width: 2px;
  min-height: 86px;
  height: 100%;
  background-color: var(--secondary-gray);
`;

export const OccurrenceTitleWrapper = styled.div`
  display: flex;
`;

export const TagText = styled.span`
  color: white;
  text-transform: uppercase;
  font-weight: bold;
  font-size: 9px;
`;

export const OccurenceTag = styled.div`
  background-color: ${({ backgroundColor }) =>
    backgroundColor && backgroundColor};
  padding: 2px 4px;
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 4px;

  i {
    color: white;
    margin-right: 4px;
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const LineTumbWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
`;

export const OccurrenceText = styled.span`
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  margin-bottom: 4px;
  color: var(--light-opacity-gray);
`;
